define('OutSystems/ClientRuntime/modules/Database/WebSQL/Upgrader/WebSQLMetadataV2Upgrader',["require", "exports", "tslib", "../../Metadata/MetadataBackupTableInfo", "../../Metadata/MetadataTableInfo", "./V0/MetadataBackupTableInfo", "./V0/MetadataTableInfo", "./WebSQLMetadataConverter"], function (require, exports, tslib_1, MetadataBackupTableInfo_1, MetadataTableInfo_1, MetadataBackupTableInfo_2, MetadataTableInfo_2, WebSQLMetadataConverter_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function migrateToV2(transaction, v0TableInfo, v2TableInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var records, newRecords;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, transaction.getAllRecords(v0TableInfo)];
                    case 1:
                        records = (_a.sent());
                        newRecords = records.map(function (record) { return (0, WebSQLMetadataConverter_1.convertV0ToV2)(record); });
                        return [4, transaction.deleteTableIfExists(v0TableInfo)];
                    case 2:
                        _a.sent();
                        return [4, transaction.createTable(v2TableInfo)];
                    case 3:
                        _a.sent();
                        return [4, transaction.upsertAllRecords(v2TableInfo, newRecords)];
                    case 4:
                        _a.sent();
                        return [2];
                }
            });
        });
    }
    function checkIfColumnExists(sqlTx, tableName, columnName) {
        return new Promise(function (resolve) {
            sqlTx.executeSql("SELECT \"".concat(tableName, "\".\"").concat(columnName, "\" FROM \"").concat(tableName, "\" LIMIT 1"), null, function () {
                resolve(true);
            }, function () {
                resolve(false);
                return false;
            });
        });
    }
    var WebSQLMetadataV2Upgrader = {
        isNeeded: function (transaction) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            var sqlTransaction, result, exists;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sqlTransaction = transaction;
                        result = false;
                        return [4, transaction.existsTable(MetadataTableInfo_2.default)];
                    case 1:
                        exists = _a.sent();
                        if (!exists) return [3, 3];
                        return [4, sqlTransaction.executeQuery(function (tx) {
                                return checkIfColumnExists(tx, MetadataTableInfo_2.default.tableName, MetadataTableInfo_2.default.attributes[0].columnName);
                            })];
                    case 2:
                        result = _a.sent();
                        _a.label = 3;
                    case 3: return [2, result];
                }
            });
        }); },
        run: function (transaction) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            var migrations;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        migrations = [
                            {
                                v0TableInfo: MetadataTableInfo_2.default,
                                v2TableInfo: MetadataTableInfo_1.default,
                            },
                            {
                                v0TableInfo: MetadataBackupTableInfo_2.default,
                                v2TableInfo: MetadataBackupTableInfo_1.default,
                            },
                        ].map(function (_a) {
                            var v0TableInfo = _a.v0TableInfo, v2TableInfo = _a.v2TableInfo;
                            return migrateToV2(transaction, v0TableInfo, v2TableInfo);
                        });
                        return [4, Promise.all(migrations)];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        }); },
        cleanup: function (transaction) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, transaction.deleteTableIfExists(MetadataTableInfo_2.default)];
                    case 1:
                        _a.sent();
                        return [4, transaction.deleteTableIfExists(MetadataBackupTableInfo_2.default)];
                    case 2:
                        _a.sent();
                        return [4, transaction.renameTable("".concat(MetadataTableInfo_1.default.tableName, "_V2"), MetadataTableInfo_1.default.tableName)];
                    case 3:
                        _a.sent();
                        return [4, transaction.renameTable("".concat(MetadataBackupTableInfo_1.default.tableName, "_V2"), MetadataBackupTableInfo_1.default.tableName)];
                    case 4:
                        _a.sent();
                        return [2];
                }
            });
        }); },
    };
    exports.default = WebSQLMetadataV2Upgrader;
});
//# sourceMappingURL=WebSQLMetadataV2Upgrader.js.map;
